import { render } from "./LayoutAidsBar.vue?vue&type=template&id=ea27f972"
import script from "./LayoutAidsBar.vue?vue&type=script&lang=js"
export * from "./LayoutAidsBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__